<div *ngIf="empty" class="transaction-gl-empty gl-preview-info">
	No general ledger lines for this transaction.
</div>

<div *ngIf="!empty" class="gl-preview-ledger">
	<h3 *ngIf="exportTitle && showScreenHeading" class="transaction-gl-screen-title">{{ exportTitle }}</h3>

	<div *ngIf="showExportActions" class="transaction-gl-export-actions">
		<button mat-stroked-button type="button" color="primary" (click)="exportXlsx()" matTooltip="Export Excel">
			<mat-icon>table_chart</mat-icon>
			Excel
		</button>
		<button mat-stroked-button type="button" (click)="exportPdf()" [disabled]="exportingPdf" matTooltip="Export PDF">
			<mat-icon>picture_as_pdf</mat-icon>
			PDF
		</button>
		<mat-spinner *ngIf="exportingPdf" diameter="22" class="transaction-gl-export-spinner"></mat-spinner>
	</div>

	<div #pdfExportRoot class="transaction-gl-pdf-root">
		<div *ngIf="!balanced" class="gl-preview-warning">
			Debits and credits do not balance. Review before posting.
		</div>

		<div class="gl-preview-table-wrap gl-preview-table-wrap--single">
		<table class="gl-preview-table gl-preview-table--ledger-sheet gl-preview-table--transaction">
			<thead>
				<tr>
					<th scope="col" class="col-period">PERIOD</th>
					<th scope="col" class="col-date">DATE</th>
					<th scope="col" class="col-acct">ACCT</th>
					<th scope="col" class="col-name">NAME</th>
					<th scope="col" class="col-narrative">NARRATIVE</th>
					<th scope="col" class="col-debit">DEBIT</th>
					<th scope="col" class="col-credit">CREDIT</th>
					<th scope="col" class="col-posted">POSTED</th>
				</tr>
			</thead>
			<tbody>
				<tr
					*ngFor="let line of normalized"
					[class.ledger-row--debit]="line.debit > 0"
					[class.ledger-row--credit]="line.credit > 0">
					<td>{{ line.period }}</td>
					<td>{{ line.date }}</td>
					<td class="mono">{{ line.accountcode || '—' }}</td>
					<td class="account-name-cell" [matTooltip]="line.account" matTooltipShowDelay="400">{{ line.account }}</td>
					<td class="narrative-cell" [matTooltip]="line.description" matTooltipShowDelay="400">{{ line.description }}</td>
					<td class="amount amount-debit">{{ line.debit > 0 ? (line.debit | currency) : '' }}</td>
					<td class="amount amount-credit">{{ line.credit > 0 ? (line.credit | currency) : '' }}</td>
					<td class="col-posted-cell">{{ line.posted }}</td>
				</tr>
			</tbody>
			<tfoot>
				<tr class="gl-preview-tfoot-row">
					<td colspan="5" class="total-label">Totals</td>
					<td class="amount amount-debit">{{ debitTotal | currency }}</td>
					<td class="amount amount-credit">{{ creditTotal | currency }}</td>
					<td></td>
				</tr>
			</tfoot>
		</table>
		</div>

		<div class="gl-preview-balance" [class.balanced]="balanced" [class.unbalanced]="!balanced">
			<span *ngIf="balanced">Balanced</span>
			<span *ngIf="!balanced">Out of balance by {{ (debitTotal - creditTotal) | currency }}</span>
		</div>
	</div>
</div>
